import React from 'react'
import { Form, Col, InputGroup, Row } from 'react-bootstrap'
import Checkbox from '../../../../components/component-items/checkbox'
import { HoverNotes } from '../../../../components/component-items/hover-notes'
import { CompanyOrderInventoryFieldsProps } from '../types'

export const OrderManagementFields = ({ settings, setSettings, context }: CompanyOrderInventoryFieldsProps) => {
  const showField = (field: keyof typeof settings) => {
    if (context === 'warehouse') return true
    const companyFields: (keyof typeof settings)[] = [
      'gestationMinutes',
      'emailCustomer',
      'useIntegrationPrices',
      'dontShipOutsideUsa',
    ]
    return companyFields.includes(field)
  }

  return (
    <Row style={{ marginTop: '.8em', marginBottom: '2em' }}>
      {showField('gestationMinutes') && (
        <Form.Group as={Col} md="6" controlId="gestationMinutes">
          <Form.Label>
            <HoverNotes
              title="Order Maturation Period (Min)"
              description="The minimum time in minutes before a newly received order becomes eligible for fulfillment. Helps prevent premature shipping of recently created orders."
            />
          </Form.Label>
          <Form.Control
            type="number"
            min="15"
            value={settings.gestationMinutes}
            onChange={(e) => setSettings({ ...settings, gestationMinutes: e.target.value })}
            required
          />
        </Form.Group>
      )}

      {showField('emailCustomer') && (
        <Col md="12">
          <InputGroup>
            <Checkbox
              selected={settings.emailCustomer}
              setSelected={() => setSettings({ ...settings, emailCustomer: !settings.emailCustomer })}
            />
            <p style={{ padding: '0 1em', lineHeight: '24px' }}>
              <HoverNotes
                description="When an order is shipped, send a confirmation email to the customer. This setting excludes Shopify as Shopify sends their own email."
                title="Send Order Confirmation Email"
              />
            </p>
          </InputGroup>
        </Col>
      )}

      {showField('useIntegrationPrices') && (
        <Col md="12">
          <InputGroup>
            <Checkbox
              selected={settings.useIntegrationPrices}
              setSelected={() => setSettings({ ...settings, useIntegrationPrices: !settings.useIntegrationPrices })}
            />
            <p style={{ padding: '0 1em' }}>Use Shopify Prices for Customs Declaration</p>
          </InputGroup>
        </Col>
      )}

      {showField('dontShipOutsideUsa') && (
        <Col md="12">
          <InputGroup>
            <Checkbox
              selected={settings.dontShipOutsideUsa}
              setSelected={() => setSettings({ ...settings, dontShipOutsideUsa: !settings.dontShipOutsideUsa })}
            />
            <p style={{ padding: '0 1em' }}>Only Ship within USA</p>
          </InputGroup>
        </Col>
      )}

      {showField('pauseReplacementOrders') && (
        <Col md="12">
          <InputGroup>
            <Checkbox
              selected={settings.pauseReplacementOrders}
              setSelected={() => setSettings({ ...settings, pauseReplacementOrders: !settings.pauseReplacementOrders })}
            />
            <p style={{ padding: '0 1em' }}>Pause Replacement Orders</p>
          </InputGroup>
        </Col>
      )}
    </Row>
  )
}
